module.exports = __webpack_public_path__ + "static/media/cubes.5b844588.png";